module.exports = __webpack_public_path__ + "static/media/kayak_disabled_ic.e5aaacc7.svg";